<template>
  <div class="b-news">
    <div class="b-news__img">
      <Anchor v-if="navigationLink" :item="navigationLink" :hide-text="true">
        <LazyImage
          v-if="newsImage"
          :image="newsImage"
          class="object-fit-cover" />
      </Anchor>
    </div>
    <div class="b-news__txts">
      <div class="b-news__txts__pub">
        {{ item.Published }}
      </div>
      <div class="b-news__txts__title">
        {{ item.Title }}
      </div>
      <div class="b-news__txts__txt" v-html="item.Text"></div>
    </div>
    <div class="b-news__cta">
      <Anchor
        v-if="navigationLink"
        :item="navigationLink"
        class="btn btn-link btn-icon-end btn-forward strong">
        <i class="icon-arrow-long-right"></i>
      </Anchor>
    </div>
  </div>
</template>

<script>
import Anchor from './common/Anchor.vue'
import LazyImage from './common/LazyImage.vue'
/* eslint-disable no-unused-vars */
import { head } from 'lodash'

export default {
  components: { Anchor, LazyImage },
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  computed: {
    navigationLink() {
      return {
        url: this.item.Lnk,
        text: this.dictionary.buttonNavigateText,
        target: '_blank',
        external: false,
      }
    },
    newsImage() {
      /* eslint-disable no-undef */
      return {
        url: _.head(this.item.Images),
        alt: this.item.Title,
      }
    },
  },
}
</script>
